import styles from './SparkShape.module.css'

export interface SparkShapeProps {
  values: number[]
  width?: number
  height?: number
  tone?: 'green' | 'ai'
}

function pointsOf(values: number[], width: number, height: number): Array<[number, number]> {
  if (values.length === 0) return []
  const min = Math.min(...values)
  const max = Math.max(...values)
  const range = max - min
  const top = Math.min(8, height / 2)
  const bottom = Math.max(top, height - 6)
  return values.map((value, index) => [
    values.length === 1 ? width / 2 : index * width / (values.length - 1),
    range === 0 ? (top + bottom) / 2 : bottom - (value - min) / range * (bottom - top),
  ])
}

function linePath(points: Array<[number, number]>): string {
  return points.map(([x, y], index) => `${index === 0 ? 'M' : 'L'}${x.toFixed(1)} ${y.toFixed(1)}`).join(' ')
}

export function SparkShape({ values, width = 140, height = 38, tone = 'green' }: SparkShapeProps) {
  const points = pointsOf(values, width, height)
  const line = linePath(points)
  const end = points.at(-1)
  const areaColor = tone === 'ai' ? 'var(--ai-blush)' : 'var(--green-050)'
  const lineColor = tone === 'ai' ? 'var(--ai-lilac)' : 'var(--green-600)'
  return (
    <svg
      className={styles.spark}
      data-component="spark-shape"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden="true"
    >
      {line ? <path d={`${line} L${width} ${height} L0 ${height} Z`} fill={areaColor} /> : null}
      {line ? <path d={line} fill="none" stroke={lineColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> : null}
      {end ? <circle cx={end[0].toFixed(1)} cy={end[1].toFixed(1)} r="3.2" fill={lineColor} /> : null}
    </svg>
  )
}
